






import DailyCustomerConsentAggregateVue from "@/components/daily-customer-consent-aggregate/DailyCustomerConsentAggregate.vue";
import Vue from "vue";

export default Vue.extend({
  data() {
    return {};
  },

  components: {
    "c-daily-customer-consent-aggregate": DailyCustomerConsentAggregateVue
  }
});
